const accessUsers = {

    PROFILE: { name: 'Profile', path: '/profile' },
    UPDATE_PROFILE: { name: 'Update Profile', path: '/update-profile' },

    USER_LIST: { name: 'User', path: '/user-list' },
    ADD_USER: { name: 'Add User', path: '/create-user' },
    UPDATE_USER: { name: 'Update User', path: '/edit-user' },
    DELETE_USER: { name: 'Delete User', path: '/delete-user' },
    USER_DETAILS: { name: 'User Details', path: '/user-details' },

}

export default accessUsers;